import React, { Component } from "react";
import { Grid, Row, Col, Modal } from "react-bootstrap";
import Pagination from "../../components/Common/pagination";
import Select from "../../components/Common/select";
import * as itemService from "../../services/itemServices";
import * as uploadService from "../../services/uploadServices";
// import Checkbox from "../../components/Common/checkbox";
// import HomeBakMasukSearch from "../bakmasuk/homeBakMasukSearch";
// import Input from "../../components/Common/input";
import MonitorItemTable from "./monitorItemTable";
import ListItemSearch from "./listItemSearch";
import { qcPackingImg } from "../../services/config.json";
import Loader from "react-loader-spinner";
import LightBox from "../../components/Common/lightbox";
import { printUrl } from "../../services/config.json";
import Input from "../../components/Common/input";
import ItemDrawingDetailTable from "./itemDrawingDetailTable";
import ItemDrawingCustomerDetailTable from './itemDrawingCustomerDetailTable';

// var XLSX = require("xlsx");
var base64 = require("base-64");

class MonitorItem extends Component {
  state = {
    items: [],
    limit: 10,
    currentPage: 1,
    maxPage: 0,
    offset: 0,
    order: "id_item",
    type: "asc",
    search: {
      code: "",
      material: "",
      finishing: "",
      customer_name: "",
    },
    drawing:[],
    hideSearch: true,
    show: [{ limit: 10 }, { limit: 25 }, { limit: 50 }, { limit: 100 }],
    sortColumn: { path: "id_item", order: "asc" },
    selectedItem: [],
    openModalDelete: false,
    status: 0,
    openModalUpload: false,
    selectedFile: null,
    allowFile: false,
    isOpen: false,
    image: "",
    allowFile: false,
    uploading: false,
    stateModalUpload: false,
    openModalUpdate: false,
    openModalPrint: false,
    itemSupplier: [],
    searchDrawing: {
      code: "",
      supplier_name: "",
      customer_name: "",
      code_supplier: "",
      customer_code: "",
      drawing_category: "",
      description: ""
    },
    openModalDetail:false,
    openModalDetailCustomer:false,
    selectedIdItem: -1,
    total: 0,
    total_cust: 0
  };
  onSort = (sortColumn) => {
    if (this.mount) {
      this.setState(
        { sortColumn, order: sortColumn.path, type: sortColumn.order },
        () => {
          this.getDataItem();
        }
      );
    }
  };
  handleChangePage = (page) => {
    const { maxPage, limit } = this.state;
    if (this.mount) {
      if (page > 0 && page < parseInt(maxPage, 10) + 1) {
        this.setState({ currentPage: page, offset: (page - 1) * limit }, () => {
          this.getDataItem();
        });
      }
    }
  };
  handleChangeLimit = ({ currentTarget: input }) => {
    const val = input.value;
    if (this.mount) {
      this.setState({ limit: val, currentPage: 1, offset: 0 }, () => {
        this.getDataItem();
      });
    }
  };
  componentDidMount() {
    this.mount = true;
    this.baseSearch = this.state.search;
    if (this.props.location.search) {
      this.initSearch1();
    } else {
      this.getDataItem();
    }
  }
  componentWillReceiveProps() {
    setTimeout(() => {
      this.initSearch1();
    }, 1000);
  }
  initSearch1 = () => {
    if (this.props.location.search) {
      let tempSearch = decodeURI(this.props.location.search).substring(7);
      const newState = JSON.parse(base64.decode(tempSearch));
      this.setState(newState, () => {
        this.fetchData();
      });
    }
  };

  componentWillUnmount() {
    this.mount = false;
  }

  fetchData = async () => {
    const { limit, offset, order, type, search } = this.state;
    itemService.getAllItem(search, limit, offset, order, type).then((data) => {
      console.log(data);
      // let temp = data.bak
      //   ? data.bak.map(bak => {
      //       return {
      //         ...bak,
      //         selected: this.getPrintedIdx(bak) >= 0 ? true : false
      //       };
      //     })
      //   : [];
      this.setState({
        items: data.item,
        maxPage: data.page,
        total: data.total,
        total_cust: data.total_cust
      });
    });
  };
  getDataItem = async () => {
    const { limit, offset, order, type, search } = this.state;
    itemService.getAllItem(search, limit, offset, order, type).then((data) => {
      console.log(data);
      // let temp = data.bak
      //   ? data.bak.map(bak => {
      //       return {
      //         ...bak,
      //         selected: this.getPrintedIdx(bak) >= 0 ? true : false
      //       };
      //     })
      //   : [];
      this.setState(
        {
          items: [],
          maxPage: data.page,
        },
        () => {
          this.props.history.push(
            "/item/list?query=" +
              base64.encode(unescape(JSON.stringify(this.state)))
          );
        }
      );
    });
  };

  toggleSearch = () => {
    const { hideSearch, search } = this.state;

    this.setState({
      hideSearch: !hideSearch,
      search: hideSearch ? search : this.baseSearch,
    });
  };

  handleChangeDate = (e, target) => {
    if (typeof e === "object") {
      let datetime = e.format("YYYY-MM-DD");
      const search = { ...this.state.search };
      search[target] = datetime;
      if (this.mount) {
        this.setState({ search });
      }
    } else {
      const search = { ...this.state.search };
      search[target] = "";
      if (this.mount) {
        this.setState({ search });
      }
    }
  };
  handleChange = ({ currentTarget: input }) => {
    const search = { ...this.state.search };
    search[input.name] = input.value;
    if (this.mount) {
      this.setState({ search });
    }
  };
  handleSubmitSearch = () => {
    this.setState({ currentPage: 1, offset: 0 }, () => {
      this.getDataItem();
    });
  };
  checkExt(val) {
    let temp = val.substring(val.length - 4);
    temp = temp.replace(".", "");
    let acceptable = false;
    if (
      temp.toLowerCase() === "jpg" ||
      temp.toLowerCase() === "png" ||
      temp.toLowerCase() === "jpeg" ||
      temp.toLowerCase() === "pdf"
    ) {
      acceptable = true;
    }
    return acceptable;
  }
  handleSelectedFile = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      allowFile: this.checkExt(event.target.files[0].name),
    });
  };
  handleShowImage = (image) => {
    if (this.mount)
      this.setState({ image, isOpen: true, openModalUpload: false });
  };
  closeLightBox = () => {
    const { stateModalUpload } = this.state;
    if (this.mount)
      this.setState({ isOpen: false, openModalUpload: stateModalUpload });
  };
  isPdf(val) {
    let pdf = false;
    if (val) {
      let temp = val.substring(val.length - 4);
      temp = temp.replace(".", "");
      if (temp.toLowerCase() === "pdf") {
        pdf = true;
      }
    }
    return pdf;
  }
  handleOpenPdf = (link) => {
    window.open(link);
  };

  handlePrint = async (item) => {
    await itemService.getItemById(item.id_item).then((data) => {
      this.setState({
        itemSupplier: data.supplier ? data.supplier : [],
        openModalPrint: true,
      });
    });
  };
  printItem = (status, id) => {
    if (status == "acc") {
      window.open(
        `${printUrl}ip-item-supplier-acc.php?id=${base64.encode(id)}
        `
      );
    } else {
      window.open(
        `${printUrl}ip-item-supplier.php?id=${base64.encode(id)}
        `
      );
    }
    this.setState({ openModalPrint: false, selectedItem: {} });
  };
  handleOpenDetailCustomer = async (item) =>{
    if(item.cust_items>0){
      this.setState({selectedIdItem: item.id_item},()=>{
        this.getDataDrawingCustomer();
      });
    }
  }
  handleOpenDetail = async (item) =>{
    if(item.items>0){
      this.setState({selectedIdItem: item.id_item},()=>{
        this.getDataDrawing();
      });
    }
  }
  handleChangeSearch = ({ currentTarget: input }) => {
    const searchDrawing = { ...this.state.searchDrawing };
    searchDrawing[input.name] = input.value;
    if (this.mount) {
      this.setState({ searchDrawing });
    }
  };
  getDataDrawing = async () =>{
    const { selectedIdItem, searchDrawing } = this.state;
    await itemService
      .getDataDrawing(selectedIdItem, searchDrawing)
      .then((data) => {  
        this.setState({drawing: data.drawing?data.drawing:[], openModalDetail:true});
      });
  }
  getDataDrawingCustomer = async () =>{
    const { selectedIdItem, searchDrawing } = this.state;
    await itemService
      .getDataDrawingCustomer(selectedIdItem, searchDrawing)
      .then((data) => {  
        this.setState({drawing: data.drawing?data.drawing:[], openModalDetailCustomer:true});
      });
  }
  handleSubmit = (e) => {
    if (e.key === "Enter") {
      this.getDataDrawing();
    }
  };
  handleOpenPdf = (link) => {
    window.open(link);
  };
  render() {
    const {
      items,
      show,
      currentPage,
      maxPage,
      limit,
      sortColumn,
      search,
      hideSearch,
      openModalDelete,
      openModalUpload,
      selectedFile,
      isOpen,
      image,
      allowFile,
      uploading,
      selectedItem,
      itemSupplier,
      openModalProduction,
      openModalPrint,
      searchDrawing,
      openModalDetail,
      openModalDetailCustomer,
      drawing,
      total,
      total_cust
    } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <h3
                style={{ cursor: "pointer" }}
                onClick={() => this.toggleSearch()}
              >
                {hideSearch ? (
                  <span>Show Search</span>
                ) : (
                  <span>Hide Search</span>
                )}
              </h3>
              {!hideSearch ? (
                <ListItemSearch
                  search={search}
                  handleChange={this.handleChange}
                  handleSubmitSearch={this.handleSubmitSearch}
                />
              ) : null}
              <div className="card">
                <div className="content">
                  <Row>
                    <Col md={3}>
                      {/* <div className="form-group">
                        <label>Show</label>
                        <InputGroup style={{ maxWidth: "200px" }}> */}
                      <Select
                        label="Show"
                        onChange={this.handleChangeLimit}
                        options={show}
                        optionValue="limit"
                        optionLabel="limit"
                        name="limit"
                        value={limit}
                      />
                      {/* 
                          <InputGroup.Addon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.setState({ openModalFilter: true })
                            }
                          >
                            <i
                              className="fa fa-cog"
                              style={{ fontSize: "25px" }}
                            />
                          </InputGroup.Addon> */}
                      {/* </InputGroup>
                      </div> */}
                    </Col>
                    <Col md={3}>
                    </Col>
                    <Col md={3}>
                      <Input
                        disabled={true}
                        value={total_cust}
                        format="number"
                        name="total_drawing_customer"
                        label="Total Customer Drawing"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        disabled={true}
                        value={total}
                        format="number"
                        name="total_drawing"
                        label="Total Supplier Drawing"
                      />
                    </Col>
                    <Col md={12} style={{ overflow: "auto" }}>
                      <MonitorItemTable
                        items={items}
                        onSort={this.onSort}
                        sortColumn={sortColumn}
                        currentPage={currentPage}
                        limit={limit}
                        handleOpenDetail={this.handleOpenDetail}
                        handleOpenDetailCustomer={this.handleOpenDetailCustomer}
                      />
                    </Col>
                    <Col md={12} style={{ textAlign: "center" }}>
                      <Pagination
                        onPageChange={this.handleChangePage}
                        currentPage={currentPage}
                        pagesCount={maxPage}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
        <Modal
          bsSize="small"
          show={openModalDelete}
          onHide={() => this.setState({ openModalDelete: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>Proceed Delete ?</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalDelete: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={() => this.proceedDelete()}
              className="btn btn-fill btn-danger"
            >
              Proceed
            </button>
          </Modal.Footer>
        </Modal>
        <LightBox
          isOpen={isOpen}
          images={image}
          closeLightBox={this.closeLightBox}
        />
        <Modal
          show={openModalPrint}
          onHide={() => this.setState({ openModalPrint: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              {itemSupplier &&
                itemSupplier.map((item, idx) => (
                  <React.Fragment>
                    <Row>
                      <Col md={12}>
                        <p>{item.supplier_name}</p>
                        <button
                          className="btn btn-fill btn-primary"
                          style={{ marginRight: "10px" }}
                          onClick={() =>
                            this.printItem("item", item.id_item_supplier)
                          }
                        >
                          Print Item
                        </button>
                        <button
                          className="btn btn-fill btn-primary"
                          style={{ marginRight: "10px" }}
                          onClick={() =>
                            this.printItem("acc", item.id_item_supplier)
                          }
                        >
                          Print Item (ACC)
                        </button>
                      </Col>
                    </Row>
                  </React.Fragment>
                ))}
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalPrint: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          bsSize="large"
          show={openModalDetail}
          onHide={() => this.setState({ openModalDetail: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail Drawing</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.drawing_category}
                        name="drawing_category"
                        label="Kategori"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.code}
                        name="code"
                        label="Kode"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.code_supplier}
                        name="code_supplier"
                        label="Kode Supplier"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.description}
                        name="description"
                        label="Deskripsi"
                      />
                    </Col>
                  </Row>
                    <Row>
                      <ItemDrawingDetailTable drawing={drawing} 
                        handleOpenPdf={this.handleOpenPdf} />
                    </Row>
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalDetail: false })}
              className="btn btn-fill btn-secondary"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize="large"
          show={openModalDetailCustomer}
          onHide={() => this.setState({ openModalDetailCustomer: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail Drawing</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.drawing_category}
                        name="drawing_category"
                        label="Kategori"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.code}
                        name="code"
                        label="Kode"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.customer_code}
                        name="customer_code"
                        label="Kode Customer"
                      />
                    </Col>
                    <Col md={3}>
                      <Input
                        onChange={this.handleChangeSearch}
                        onKeyPress={e => this.handleSubmit(e)}
                        value={searchDrawing.description}
                        name="description"
                        label="Deskripsi"
                      />
                    </Col>
                  </Row>
                    <Row>
                      <ItemDrawingCustomerDetailTable drawing={drawing} 
                        handleOpenPdf={this.handleOpenPdf} />
                    </Row>
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalDetailCustomer: false })}
              className="btn btn-fill btn-secondary"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        {uploading && (
          <div style={{ position: "absolute", top: "50vh", left: "50%" }}>
            <Loader type="Circles" color="#00BFFF" height="50" width="50" />
          </div>
        )}
      </div>
    );
  }
}

export default MonitorItem;



// WEBPACK FOOTER //
// ./src/views/item/monitor.jsx